var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { memo, useMemo } from 'react';
import chroma from 'chroma-js';
import { styled } from '@web/theme';
import { ButtonContent } from './ButtonContent';
export var Button = memo(function (_a) {
    var onClick = _a.onClick, cta = _a.cta, children = _a.children, icon = _a.icon, props = __rest(_a, ["onClick", "cta", "children", "icon"]);
    var submit = false;
    var _onClick = function (e) {
        e.preventDefault();
        onClick(e);
    };
    var ButtonTag = useMemo(function () { return cta ? CtaButton : DefaultButton; }, [cta]);
    return (React.createElement(ButtonTag, __assign({ onClick: _onClick }, props, { type: submit ? 'submit' : 'button' }),
        React.createElement(ButtonContent, { icon: icon }, children)));
});
export var DefaultButton = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\toutline: none;\n\tborder: none;\n\tdisplay: flex;\n\tcursor: pointer;\n\tline-height: 100%;\n\tpadding: .3rem .6rem;\n\tcolor: ", ";\n\tbackground-color: ", ";\n\tborder-radius: ", ";\n\t\n\t&:hover {\n\t\tcolor: ", ";\n\t\tbackground-color: ", ";\n\t}\n\t\n\t&:disabled {\n\t\tcolor: ", ";\n\t\tbackground-color: ", ";\n\t}\n"], ["\n\toutline: none;\n\tborder: none;\n\tdisplay: flex;\n\tcursor: pointer;\n\tline-height: 100%;\n\tpadding: .3rem .6rem;\n\tcolor: ", ";\n\tbackground-color: ", ";\n\tborder-radius: ", ";\n\t\n\t&:hover {\n\t\tcolor: ", ";\n\t\tbackground-color: ", ";\n\t}\n\t\n\t&:disabled {\n\t\tcolor: ", ";\n\t\tbackground-color: ", ";\n\t}\n"])), function (_a) {
    var theme = _a.theme;
    return theme.button.txt;
}, function (_a) {
    var active = _a.active, theme = _a.theme;
    return active ? theme.brand.bg : theme.button.bg;
}, function (_a) {
    var theme = _a.theme;
    return theme.vars.baseBorderRadius;
}, function (_a) {
    var theme = _a.theme;
    return chroma(theme.button.txt).darken(.3).hex();
}, function (_a) {
    var theme = _a.theme;
    return chroma(theme.button.bg).darken(.3).hex();
}, function (_a) {
    var theme = _a.theme;
    return chroma(theme.button.txt).alpha(.3).hex();
}, function (_a) {
    var theme = _a.theme;
    return chroma(theme.button.bg).alpha(.3).hex();
});
var CtaButton = styled(DefaultButton)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tcolor: ", ";\n\tbackground-color: ", ";\n\t\n\t&:hover {\n\t\tcolor: ", ";\n\t\tbackground-color: ", ";\n\t}\n"], ["\n\tcolor: ", ";\n\tbackground-color: ", ";\n\t\n\t&:hover {\n\t\tcolor: ", ";\n\t\tbackground-color: ", ";\n\t}\n"])), function (_a) {
    var theme = _a.theme;
    return theme.cta.txt;
}, function (_a) {
    var theme = _a.theme;
    return theme.cta.bg;
}, function (_a) {
    var theme = _a.theme;
    return chroma(theme.cta.txt).darken(.3).hex();
}, function (_a) {
    var active = _a.active, theme = _a.theme;
    return active ? theme.brand.bg : chroma(theme.cta.bg).darken(.3).hex();
});
export var Fab = styled(Button)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tmin-height: ", "px;\n\tmin-width: ", "px;\n\talign-items: center;\n\tjustify-content: center;\n\tfont-size: 1.1rem;\n\tpadding: .2rem 1rem;\n\tbox-shadow: ", ";\n\tborder-radius: ", ";\n\tz-index: 580;\n\t\n\t&:hover {\n\t\tbox-shadow: ", ";\n\t}\n"], ["\n\tmin-height: ", "px;\n\tmin-width: ", "px;\n\talign-items: center;\n\tjustify-content: center;\n\tfont-size: 1.1rem;\n\tpadding: .2rem 1rem;\n\tbox-shadow: ", ";\n\tborder-radius: ", ";\n\tz-index: 580;\n\t\n\t&:hover {\n\t\tbox-shadow: ", ";\n\t}\n"])), function (_a) {
    var theme = _a.theme;
    return theme.vars.fabSize;
}, function (_a) {
    var theme = _a.theme;
    return theme.vars.fabSize;
}, function (_a) {
    var theme = _a.theme;
    return theme.boxShadow.default;
}, function (_a) {
    var theme = _a.theme;
    return theme.vars.baseBorderRadius;
}, function (_a) {
    var theme = _a.theme;
    return theme.boxShadow.hover;
});
var templateObject_1, templateObject_2, templateObject_3;
